import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    styled,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TablePermissionControl from 'src/component-project/PermissionControlPages/TablePermissionControlScreen';
import { DecentralizationListHead } from 'src/sections/@dashboard/decentralization';
import TextInput from '../Input/TextInput';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Loader from '../loader/loader';
import ButtonAction from '../Button.js/SaveButton';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const CreateScreenModal = ({ visible = false, setVisible, dataUpdate, isEdit, fuctGet, valueUser }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [value, setValue] = useState({
        icons: '',
        screens_key: '',
        navigate: '',
        icons_mobile: '',
        navigate_mobile: '',
    });
    const [workStatus, setWorkStatus] = useState(true);
    // const [permissScreen, setPermissScreen]= useState({
    //     search: "2",
    //     insert: "2",
    //     update: "2",
    //     delete: "2",
    //     block: "2",
    //     import: "2",
    //     export: "2"
    // });
    const checked = useRef(false);

    const [flagAddStat, setFlagAddStat] = useState(false);
    const addFlag = useRef(false);
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        if (isEdit) {
            setValue({
                icons: dataUpdate.icons,
                screens_key: dataUpdate.screens_key,
                navigate: dataUpdate.navigate,
                icons_mobile: dataUpdate.icons_mobile,
                navigate_mobile: dataUpdate.navigate_mobile,
            });
            setWorkStatus(dataUpdate.work_status === '1' ? true : false);
        } else {
            setValue({
                icons: '',
                screens_key: '',
                navigate: '',
                icons_mobile: '',
                navigate_mobile: '',
            });
        }
    }, [visible]);

    const tableDataHeader = [
        { id: 1, label: t('view'), alignRight: false },
        { id: 2, label: t('insert'), alignRight: false },
        { id: 3, label: t('update'), alignRight: false },
        { id: 4, label: t('delete'), alignRight: false },
        { id: 5, label: t('lock'), alignRight: false },
        { id: 6, label: t('import'), alignRight: false },
        { id: 7, label: t('export'), alignRight: false },
    ];

    const handleOnChangeText = (e, key = 'name') => {
        setValue({ ...value, [key]: e });
    };

    // const handleChange = (event, key) => {
    //     checked.current = event.target.checked
    //     if (checked.current) {
    //         setPermissScreen({
    //             ...permissScreen,
    //             [key]: permissScreen[key] === '2' ? '0' : '2'
    //         })
    //     }
    // };

    const handleSubmit = () => {
        // console.log('handleSubmit', value);
        setIsSubmit(true);
        if (addFlag.current === true) return;
        if (!value.icons || !value.screens_key || !value.navigate) return toast.error(t('error.param'));

        addFlag.current = true;
        setFlagAddStat(true);

        if (isEdit) {
            let InVal = [
                dataUpdate.screen_id,
                value.icons,
                value.screens_key,
                value.navigate,
                value.icons_mobile,
                value.navigate_mobile,
            ];
            sendRequest(serviceList.updateScreen, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            let InVal = [
                value.icons,
                value.screens_key,
                value.navigate,
                value.icons_mobile,
                value.navigate_mobile,
                '1',
            ];
            sendRequest(serviceList.createScreen, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet(valueUser || '1');
            setVisible(!visible);
            setIsSubmit(false);
            setValue({
                screens: '',
                icons: '',
                screens_key: '',
                navigate: '',
                icons_mobile: '',
                screens_key_mobile: '',
                navigate_mobile: '',
            });
            setWorkStatus();
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    const handleCancel = () => {
        setVisible(!visible);
        setValue({
            screens: '',
            icons: '',
            screens_key: '',
            navigate: '',
            icons_mobile: '',
            screens_key_mobile: '',
            navigate_mobile: '',
        });
        // setPermissScreen({
        //     search: "2",
        //     insert: "2",
        //     update: "2",
        //     delete: "2",
        //     block: "2",
        //     import: "2",
        //     export: "2"
        // });
        setIsSubmit(false);
        setWorkStatus();
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={handleCancel}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleCancel}>
                {isEdit ? t('update_screen') : t('create_screen')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('screens_key')}
                            valueChange={value.screens_key}
                            getValue={(e) => handleOnChangeText(e, 'screens_key')}
                            required
                            error={!value.screens_key && isSubmit}
                            helperText={!value.screens_key && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('icons')}
                            valueChange={value.icons}
                            getValue={(e) => handleOnChangeText(e, 'icons')}
                            required
                            error={!value.icons && isSubmit}
                            helperText={!value.icons && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('icons_mobile')}
                            valueChange={value.icons_mobile}
                            getValue={(e) => handleOnChangeText(e, 'icons_mobile')}
                            // required
                            // error={!value.icons_mobile && isSubmit}
                            // helperText={!value.icons_mobile && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('navigate')}
                            valueChange={value.navigate}
                            getValue={(e) => handleOnChangeText(e, 'navigate')}
                            required
                            error={!value.navigate && isSubmit}
                            helperText={!value.navigate && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('navigate_mobile')}
                            valueChange={value.navigate_mobile}
                            getValue={(e) => handleOnChangeText(e, 'navigate_mobile')}
                            // required
                            // error={!value.navigate_mobile && isSubmit}
                            // helperText={!value.navigate_mobile && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    {/* <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <FormGroup>
                            <FormControlLabel 
                                label={t('active')} 
                                control={
                                    <Switch 
                                        checked={workStatus}
                                        onChange={(e) => {setWorkStatus(e.target.checked)}}
                                        defaultChecked 
                                    />
                                } 
                            />
                        </FormGroup>
                    </Grid> */}
                    {/* <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TableContainer sx={{ paddingTop: 2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {tableDataHeader.map((headCell, index) => (
                                            <TableCell key={index}>
                                                <TableHead>{headCell.label}</TableHead>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover tabIndex={-1} role="checkbox">
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'search')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'insert')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'update')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'delete')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'block')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'import')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                onChange={(e) => handleChange(e, 'export')}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid> */}
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonAction onClick={handleCancel} type={'cancel'} title={t('cancel')} />

                <ButtonAction
                    onClick={handleSubmit}
                    type={isEdit ? 'update' : 'save'}
                    title={isEdit ? t('update') : t('save')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CreateScreenModal;
